import React from "react";
import get from "lodash/get";
import { object, number, array } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";
import PlaceholderImage from "../../atoms/placeholder-image";
import CardImage from "../../atoms/card-image";

import "./card-image-type-6.m.css";

const CardImageType6 = ({ story, headlineLimit, widths = [250, 480, 764] }) => {
  const slug = story["hero-image-s3-key"];
  const storyImageSlug = get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], slug);
  return (
    <Link href={`/${story.slug}`}>
      <div styleName="wrapper" className="card-image-type-6">
        {storyImageSlug ? (
          <CardImage story={story} defaultWidth={36} aspectRatio={[16, 9]} imageType="image16x9" widths={widths} />
        ) : (
          <PlaceholderImage story={story} />
        )}
        <Headline story={story} headerType={2} headerLevel={2} headlineLimit={headlineLimit} />
      </div>
    </Link>
  );
};

export default CardImageType6;

CardImageType6.propTypes = {
  story: object,
  headlineLimit: number,
  widths: array
};
